var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDiaryFilledPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1734 4.32704C25.1461 3.29984 23.4907 3.29984 22.4635 4.32704L4.82631 21.9642C3.79911 22.9914 3.79911 24.6469 4.82631 25.6741C5.33992 26.1877 6.02516 26.4162 6.70989 26.4162C7.39463 26.4162 8.07987 26.1881 8.59347 25.6741L26.2306 8.03692C27.2009 7.00972 27.201 5.35465 26.1734 4.32704Z",
    fill: "#805AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5617 6.78086C11.5617 9.14502 9.64502 11.0617 7.28086 11.0617C4.91671 11.0617 3 9.14502 3 6.78086C3 4.4163 4.91671 2.5 7.28086 2.5C9.64502 2.5 11.5617 4.4163 11.5617 6.78086Z",
    fill: "#805AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.999 23.2193C27.999 25.5835 26.0823 27.5002 23.7181 27.5002C21.354 27.5002 19.4373 25.5835 19.4373 23.2193C19.4373 20.8552 21.354 18.9385 23.7181 18.9385C26.0823 18.9385 27.999 20.8552 27.999 23.2193Z",
    fill: "#805AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDiaryFilledPercentage);
export default __webpack_public_path__ + "static/media/TotalDiaryFilledPercentage.f11d2cd0e9a64b222d1d80a2034549b4.svg";
export { ForwardRef as ReactComponent };